/* esm.sh - applesauce-loaders@5.1.0/dist/helpers/upstream */
export * from "/*applesauce-loaders@5.1.0/esnext/dist/helpers/upstream.mjs";
